import * as React from "react";
import { Button } from "antd";

export interface State {}

export interface Props {
  translate: any;
  onRemoveBtnClick: any;
}

export default class AttributeActionBox extends React.Component<Props, State> {
  render() {
    const { translate, onRemoveBtnClick } = this.props;

    return (
      <Button size="small" type={"danger"} onClick={() => onRemoveBtnClick()}>
        {translate("attribute_actions_bar.remove")}
      </Button>
    );
  }
}
